// extracted by mini-css-extract-plugin
export default {"chatBtn":"EPhrq7974RHOYqGr4WI4","chatWrapper":"GUiX8kKS8DIhVCgKfxZY"};